import { cn } from "@/utils";
import React from "react";

type SHeadingProps = {
    children?: React.ReactNode
    text?: string;
    className?: string;
    tAlign?: "center" | "left" | "right";
};

const SHeading: React.FC<SHeadingProps> = ({ text, children, tAlign = "left", className }) => {
    return (
        <h2
            className={cn(
                "font-bold text-primary leading-tight sm:leading-10",
                {
                    "text-center": tAlign === "center",
                    "text-left": tAlign === "left",
                    "text-right": tAlign === "right",
                },
                className
            )}
        >
            {text || children}
        </h2>
    );
};

export default SHeading;
